import React, { Component } from 'react';
import { connect } from "react-redux";
import { Card, CardBody, CardHeader, Button, Col, Row } from 'reactstrap';
import { SlPageTitle, SlFormEntryRow, SlMoneyInput, SlButton, SlBusyIndicator  } from './editors'
import { metadataService, newLoanStepperService, newLoanService, workflowService, SessionService, ProfileService, ProfileApi } from '../_services';
import { history } from '../_helpers';
import { newLoanActions, profileActions, userActions } from "../_actions";
import validator from 'validator';
import Stepper from "./subcomponents/Stepper";
import { userService } from '../_services/user.service';

class FundingAmount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            steps: [],
            currentStep: 0,
            fieldErrors: [],
            cashNeeded: null,
            minLoanAmount: null,
            maxLoanAmount: null,
            hasErrors: true,
            isBusy : true
        }

        this.handleInput = this.handleInput.bind(this);        
    }

    async componentDidMount() {
        let workflowData = workflowService.getCurrentWorkflowStepData();

        if (workflowData) {
            let newState = {
                steps: newLoanStepperService(workflowData.workflowId),
                currentStep: workflowData.currentStepperStep, 
                isBusy : false
            };

            let personalInfo = SessionService.getPersonalInfo();
            if (personalInfo) {
                newState.cashNeeded = personalInfo.requestedAmount;
            }else{                
                personalInfo = (await this.getExtendedProfileInfo()).personalInfo;
            }
            await this.updateLoanAmounts(personalInfo.state); 
            newState.hasErrors = this.formHasErrors(newState.cashNeeded);
            this.setState(newState);
            
        }
        else {
            history.push("/LogInMain");
        }
    }

    updateLoanAmounts = async(state) => {
        return newLoanService.validateState(state).then(stateValidation => {
            let { doesBusinessInState, minLoanAmount, maxLoanAmount } = stateValidation.data;

            if (!doesBusinessInState) {
                minLoanAmount = null;
                maxLoanAmount = null;
            }

            this.setState({
                minLoanAmount,
                maxLoanAmount
            });
        });
    }

    formHasErrors(newAmount) {
        let hasErrors = false; 
        if (newAmount && newAmount > 0) {
            if (this.state.maxLoanAmount && parseFloat(newAmount) > this.state.maxLoanAmount) {               
                hasErrors = true;
            }
            else if (this.state.minLoanAmount && parseFloat(newAmount) < this.state.minLoanAmount) {                
                hasErrors = true;
            }
        } else {
            hasErrors = true;
        }

        this.setState({ hasErrors });
        
        return hasErrors;
    }

    handleInput(e) {
        const newAmount = parseFloat(e.target.value);
        const hasErrors = this.formHasErrors(newAmount);
        this.setState({ cashNeeded: newAmount, hasErrors: hasErrors});
    }

    handleBack = () => {
        const { dispatch } = this.props;
        dispatch(newLoanActions.handleLoanAmountBack());
    }

    handleSubmit = () => {
        if (this.state.fieldErrors.length === 0) {
            const { dispatch } = this.props;
            dispatch(newLoanActions.loanAmount(this.state.cashNeeded));
        };
    }
   async getExtendedProfileInfo(){
      return await ProfileApi.getExtendedProfileInfo()
        .then(result => result.data)
        .then(profile => {
            return ProfileService.loadExtendedProfileInfoInSession(profile)
        });
    }
    render() {
        const { isBusy} = this.state;
        return (
            <div>
                <div className="text-center">
                    <Stepper stepData={this.props.steps} currentStep={this.props.currentStep} />
                </div>
                <SlFormEntryRow>
                    <SlPageTitle pageName="NewLoan" />
                </SlFormEntryRow>
                <SlBusyIndicator visible={isBusy}/>
                {isBusy!==true && <Card className={ "text-center" }>
                    <CardBody>
                        <div className="text-center">
                            <SlFormEntryRow>
                                {metadataService.getLabel("CashNeeded")}
                            </SlFormEntryRow>
                            <SlFormEntryRow>
                                <SlMoneyInput
                                    name="RequestedAmount"
                                    value={this.state.cashNeeded}
                                    fieldErrors={this.state.fieldErrors}
                                    onChange={this.handleInput}
                                    maxValue={999999}
                                    isRequired={true}
                                    showLabel={false}
                                    minAmount={this.state.minLoanAmount}
                                    maxAmount={this.state.maxLoanAmount}
                                     />
                            </SlFormEntryRow>
                        </div>
                    </CardBody>
                </Card>}
                <SlFormEntryRow>
                    <div className="text-center">                        
                        <SlButton name="Next" onClick={this.handleSubmit} disabled={this.state.hasErrors} />
                    </div>
                </SlFormEntryRow>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { loggedIn } = state.authentication;
    const { steps, currentStep } = state.users;
    const { userState } = state.registration;

    return {
        loggedIn, steps, currentStep, userState
    };
}

const connectedFundingAmount = connect(mapStateToProps)(FundingAmount);
export { connectedFundingAmount as FundingAmount };